class Vessel {
    id = null;
    registered_flag_id = null;
    port_of_registry_id = null;
    vessel_type_id = null;
    vessel_size_id = null;
    year_built = '';
    dwt = '';
    gt = '';
    loa = '';
    pumping_system_id = null;
    cargo_handling_gear_id = null;
    propulsion_power = '';
    engine_type_id = null;
    engine_model = '';
    dp_type_id = null;
    dp_manufacturer_id = null;
    shipbuilder = '';
    imo = '';
    call_sign = '';
    cargo_handling_gear = '';
    pumping_system = '';
    port_of_registry = '';

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default Vessel;
